export default __webpack_public_path__ + "4de804828ea611e1c658174dede90c32.woff2";